import { render, staticRenderFns } from "./characterDetails.vue?vue&type=template&id=2dcaaef5&scoped=true"
import script from "./characterDetails.vue?vue&type=script&lang=js"
export * from "./characterDetails.vue?vue&type=script&lang=js"
import style0 from "./characterDetails.vue?vue&type=style&index=0&id=2dcaaef5&prod&scoped=true&lang=css"
import style1 from "./characterDetails.vue?vue&type=style&index=1&id=2dcaaef5&prod&lang=css"
import style2 from "./characterDetails.vue?vue&type=style&index=2&id=2dcaaef5&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2dcaaef5",
  null
  
)

export default component.exports